import { useEffect, useContext } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import HelperText from "../Content/HelperText";

import IconInfo from "../../Images/static/media/svg/info.svg";

import CalculatorContext from "../../Context/CalculatorContext";

/* eslint-disable max-len */
function StepFourPage() {
  const {
    setCurrentStepIndex,
    energySource,
    isEmissionKnown,
    customEmission,
    setCustomEmission,
    fuelConsumptionAmount,
    setFuelConsumptionAmount,
    fuelConsumptionType,
    setFuelConsumptionType,
    useDefaultFernwarmeFactor,
    setUseDefaultFernwarmeFactor,
    customFernwarmeFactor,
    setCustomFernwarmeFactor,
  } = useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(3);

    if (isEmissionKnown === "0") {
      setCustomEmission(0);
    }
  }, [setCurrentStepIndex, setCustomEmission, isEmissionKnown]);

  return (
    <div className="tx-kalo form-steps-abwizard">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              {isEmissionKnown === "1" ? (
                <>
                  <StepsHeadline>
                    <h4 className="element-header text-center">
                      Wie hoch ist die{" "}
                      <span className="text-primary">
                        jährliche CO<sub>2</sub>-Emissionsmenge
                      </span>{" "}
                      Ihrer Liegenschaft?
                    </h4>
                  </StepsHeadline>

                  <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                    <div className="frame-container frame-container-default">
                      <div className="frame-inner">
                        <div className="tx-powermail">
                          <div className="wrap-fluid">
                            <StepsForm>
                              <fieldset className="powermail_fieldset">
                                <div className="row justify-content-center">
                                  <div className="col-md-6 col-lg-5 text-center">
                                    <fieldset className="form-group">
                                      <div className="powermail_fieldwrap">
                                        <div className="form-floating">
                                          <input
                                            aria-required="true"
                                            placeholder="Gesamtwohnfläche -  (m<sup>2</sup>)"
                                            className="form-control form-control-zip-custom powermail_input"
                                            id="living-space"
                                            type="number"
                                            required="required"
                                            pattern="\[0-9]*\.?\,?\d{2}"
                                            step={0.01}
                                            min={1}
                                            value={customEmission}
                                            onKeyDown={(e) => {
                                              if (
                                                ![
                                                  "0",
                                                  "1",
                                                  "2",
                                                  "3",
                                                  "4",
                                                  "5",
                                                  "6",
                                                  "7",
                                                  "8",
                                                  "9",
                                                  ",",
                                                  ".",
                                                  "Backspace",
                                                ].includes(e.key) ||
                                                [192, 229].includes(e.keyCode) ||
                                                (e.key === "0" && !customEmission)
                                              ) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }
                                            }}
                                            onChange={(e) => {
                                              setCustomEmission(e.target.value);
                                            }}
                                          />

                                          <label htmlFor="living-space" title="">
                                            CO<sub>2</sub>-Emissionen (kg)
                                            <span className="mandatory">*</span>
                                          </label>
                                        </div>
                                      </div>
                                    </fieldset>

                                    <div className="form-group pt-3">
                                      <input
                                        className="btn btn-secondary"
                                        type="submit"
                                        value="Weiter"
                                        disabled={customEmission === ""}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            </StepsForm>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <HelperText>
                    <p>
                      Bitte geben Sie die CO<sub>2</sub>-Emissionsmenge für Ihre Liegenschaft an,
                      die Ihr Energieversorgunger auf der Rechnung ausgewiesen hat.
                    </p>
                  </HelperText>
                </>
              ) : (
                <>
                  <StepsHeadline>
                    <h4 className="element-header text-center">
                      Wie hoch ist der{" "}
                      <span className="text-primary">jährliche Brennstoffverbrauch </span> Ihrer
                      Liegenschaft?
                    </h4>
                  </StepsHeadline>

                  <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                    <div className="frame-container frame-container-default">
                      <div className="frame-inner">
                        <div className="tx-powermail">
                          <div className="wrap-fluid">
                            <StepsForm>
                              <fieldset className="powermail_fieldset">
                                <div className="row justify-content-center">
                                  <div className="col-md-10 col-lg-8 text-center">
                                    <fieldset className="form-group">
                                      <div className="powermail_fieldwrap powermail_fieldwrap_inline_group">
                                        <div className="form-floating">
                                          <input
                                            aria-required="true"
                                            placeholder="Wert Brennstoffverbrauch"
                                            className="form-control form-control-zip-custom powermail_input"
                                            id="fuel-consumption-amount"
                                            type="number"
                                            required="required"
                                            pattern="\[0-9]*\.?\,?\d{6}"
                                            step={0.000001}
                                            min={0}
                                            value={fuelConsumptionAmount}
                                            onKeyDown={(e) => {
                                              if (
                                                ![
                                                  "0",
                                                  "1",
                                                  "2",
                                                  "3",
                                                  "4",
                                                  "5",
                                                  "6",
                                                  "7",
                                                  "8",
                                                  "9",
                                                  ",",
                                                  ".",
                                                  "Backspace",
                                                ].includes(e.key) ||
                                                [192, 16].includes(e.keyCode) ||
                                                (e.key === "0" && !fuelConsumptionAmount)
                                              ) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }
                                            }}
                                            onChange={(e) => {
                                              setFuelConsumptionAmount(e.target.value);
                                            }}
                                          />

                                          <label htmlFor="fuel-consumption-amount" title="">
                                            Wert Brennstoffverbrauch
                                            <span className="mandatory">*</span>
                                          </label>
                                        </div>

                                        <div
                                          className="btn-group btn-group-toggler"
                                          role="group"
                                          aria-label="Basic radio toggle button group"
                                        >
                                          <input
                                            type="radio"
                                            className="btn-check"
                                            name="btnradio"
                                            id="btnradio1"
                                            value="kWh"
                                            checked={fuelConsumptionType === "kWh"}
                                            onChange={(e) => {
                                              setFuelConsumptionType(e.target.value);
                                            }}
                                          />
                                          <label
                                            className="btn btn-outline-secondary btn-step-two"
                                            htmlFor="btnradio1"
                                          >
                                            kWh
                                          </label>

                                          {energySource === "Heizöl" ||
                                          energySource === "Flüssiggas" ? (
                                            <>
                                              <input
                                                type="radio"
                                                className="btn-check"
                                                name="btnradio"
                                                id="btnradio2"
                                                value="l"
                                                checked={fuelConsumptionType === "l"}
                                                onChange={(e) => {
                                                  setFuelConsumptionType(e.target.value);
                                                }}
                                              />
                                              <label
                                                className="btn btn-outline-secondary btn-step-two"
                                                htmlFor="btnradio2"
                                              >
                                                l
                                              </label>
                                            </>
                                          ) : (
                                            <>
                                              <input
                                                type="radio"
                                                className="btn-check"
                                                name="btnradio"
                                                id="btnradio2"
                                                value="m<sup>3</sup>"
                                                checked={fuelConsumptionType === "m<sup>3</sup>"}
                                                onChange={(e) => {
                                                  setFuelConsumptionType(e.target.value);
                                                }}
                                              />
                                              <label
                                                className="btn btn-outline-secondary btn-step-two"
                                                htmlFor="btnradio2"
                                              >
                                                m<sup>3</sup>
                                              </label>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </fieldset>

                                    {energySource === "Fernwärme" ? (
                                      <>
                                        <div className="form-group">
                                          <div className="form-check form-switch m-0 ps-0 d-flex align-items-center">
                                            <input
                                              className="form-check-input ms-1 me-4 flex-shrink-0"
                                              type="checkbox"
                                              value="1"
                                              checked={useDefaultFernwarmeFactor}
                                              onChange={(e) => {
                                                setUseDefaultFernwarmeFactor(e.target.checked);
                                              }}
                                            />
                                            <div className="d-flex">
                                              <p className="m-0">
                                                Bundesweiten CO<sub>2</sub>-Emissionsfaktor 255,3
                                                g/kWh verwenden
                                              </p>

                                              <div className="mx-3">
                                                <a
                                                  href="#"
                                                  data-bs-target="#fernwarme"
                                                  tabIndex="0"
                                                  data-bs-toggle="modal"
                                                  className="accordion-button-additional-modal-trigger"
                                                  aria-label="Open district heating information modal"
                                                >
                                                  <img
                                                    className="accordion-button-additional-modal-icon"
                                                    src={IconInfo}
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        {useDefaultFernwarmeFactor ? null : (
                                          <fieldset className="form-group">
                                            <div className="powermail_fieldwrap powermail_fieldwrap_inline_group">
                                              <div className="form-floating">
                                                <input
                                                  // aria-required="true"
                                                  placeholder="g/kWH"
                                                  className="form-control form-control-zip-custom powermail_input"
                                                  id="custom-fernwarme-factor"
                                                  type="number"
                                                  // required="required"
                                                  pattern="\[0-9]*\.?\,?\d{6}"
                                                  step={0.000001}
                                                  min={0}
                                                  value={customFernwarmeFactor}
                                                  onKeyDown={(e) => {
                                                    if (
                                                      ![
                                                        "0",
                                                        "1",
                                                        "2",
                                                        "3",
                                                        "4",
                                                        "5",
                                                        "6",
                                                        "7",
                                                        "8",
                                                        "9",
                                                        ",",
                                                        ".",
                                                        "Backspace",
                                                      ].includes(e.key) ||
                                                      [192, 16].includes(e.keyCode) ||
                                                      (e.key === "0" && !customFernwarmeFactor)
                                                    ) {
                                                      e.preventDefault();
                                                      e.stopPropagation();
                                                    }
                                                  }}
                                                  onChange={(e) => {
                                                    setCustomFernwarmeFactor(e.target.value);
                                                  }}
                                                />

                                                <label htmlFor="custom-fernwarme-factor" title="">
                                                  g/kWH
                                                </label>
                                              </div>
                                            </div>
                                          </fieldset>
                                        )}
                                      </>
                                    ) : null}

                                    <div className="form-group pt-3">
                                      <input
                                        className="btn btn-secondary"
                                        type="submit"
                                        value="Weiter"
                                        disabled={
                                          energySource === "Fernwärme" && !useDefaultFernwarmeFactor
                                            ? fuelConsumptionAmount === "" ||
                                              customFernwarmeFactor === ""
                                            : fuelConsumptionAmount === ""
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            </StepsForm>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <HelperText>
                    <p>
                      Bitte geben Sie an dieser Stelle den Brennstoffverbrauch Ihrer Liegenschaft an
                      und wählen die dazugehörige Einheit aus.
                    </p>
                  </HelperText>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepFourPage;
